<template>
  <v-tooltip v-if="status === 'IN_QUEUE'" bottom>
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
        class="d-flex align-center justify-start"
        style="cursor: hover"
      >
        <v-icon left size="18" :class="['mr-2', colorIcon]">{{ icon }}</v-icon>
        <span class="text-truncate" style="flex: 1">
          {{ formattedStatus }}
        </span>
      </span>
    </template>
    <span>
      <b>{{ tooltipMessage }}</b>
    </span>
  </v-tooltip>

  <span v-else class="d-flex align-center justify-start">
    <v-icon left size="18" :class="['mr-2', colorIcon]">{{ icon }}</v-icon>
    <span class="text-truncate" style="flex: 1">
      {{ formattedStatus }}
    </span>
  </span>
</template>

<script>
import { getMigrationStatusCode } from "@/helpers/variables/migrations";

export default {
  name: "Status",

  props: {
    status: { type: String, default: "" },
  },
  computed: {
    config() {
      return getMigrationStatusCode()[this.status] || {};
    },
    formattedStatus() {
      return this.config.formattedStatus;
    },
    tooltipMessage() {
      return this.config.tooltipMessage;
    },
    icon() {
      return this.config.icon;
    },
    colorIcon() {
      return this.config.colorIcon;
    },
  },
};
</script>
